module.exports = __webpack_public_path__ + "img/img-afafb143.17ccfa3b.png";